import BulkQuestionUploadDispatcherFactory from './BulkQuestionUploadDispatcherFactory';
import { IBulkQuestionUploadDispatcherFactoryMethod as IBulkQuestionUploadDispatcherFactory } from './interfaces';
import { DIUploadTypes } from '../types';

export const { BulkQuestionUploadDispatcher } = DIUploadTypes;

export type { IBulkQuestionUploadDispatcherFactory };

export default BulkQuestionUploadDispatcherFactory;
